import React, { useEffect, useState } from "react";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import { useStore } from "../hooks/useStore";
import {
  ProductListAction,
  toggleBranchProductAction,
  setVariantStockAction,
} from "../redux/actions/productAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import VariantsModal from "./variants-modal";
import { FadeLoader } from "react-spinners";
const ItemsManagement = () => {
  const { storeData } = useStore();
  // console.log("storeData", storeData);

  const dispatch = useDispatch();
  const { productList, loader } = useSelector((state) => state.product);

  useEffect(() => {
    if (storeData?.data?._id) {
      dispatch(
        ProductListAction({
          store:
            storeData?.data?.mainBranchStoreId?._id || storeData?.data?._id,
          branchId: storeData?.data?._id,
        }),
      );
    }
  }, [storeData, dispatch]);

  // Local list of items
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (productList?.data) {
      const formattedItems = productList.data.map((prod) => ({
        id: prod._id,
        name: prod.product_name || "Item",
        category: prod.subCategoryInfo?.sub_category_name || "standard",
        price:
          prod.price ||
          prod.productVariants?.find((v) => v.default)?.price ||
          prod.productVariants?.[0]?.price ||
          0,
        stock: prod.quantity || 0,
        status: prod.isEnabledForBranch ? "Active" : "Inactive",
        isEnabledForBranch: prod.status !== "Active",
        variants: prod.productVariants || [],
        size:
          prod.productVariants?.find((v) => v.default)?.size ||
          prod.productVariants?.[0]?.size ||
          "Regular",
        image: prod.image || null,
        productNumber: prod.product_number || "",
        type: prod.type || "",
        description: prod.description || "",
        addOns: prod.addOns || [],
        choices: prod.choices || [],
      }));
      setItems(formattedItems);
    }
  }, [productList]);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showVariantsModal, setShowVariantsModal] = useState(false);

  const handleViewVariants = (product) => {
    setSelectedProduct(product);
    setShowVariantsModal(true);
  };

  const handleVariantStockChange = (
    productId,
    variantId,
    action,
    value = null,
  ) => {
    const item = items.find((i) => i.id === productId);
    if (!item) return;
    const variant = item.variants?.find(
      (v) => v._id === variantId || v.variantId === variantId,
    );
    if (!variant) return;

    let originalStock = variant.branchStock ? variant.branchStock.stock : null;
    let originalIsUnlimited = variant.branchStock
      ? variant.branchStock.isUnlimited
      : true;

    let currentStock = originalStock;
    if (
      currentStock === "" ||
      currentStock === null ||
      currentStock === undefined
    ) {
      currentStock = 0;
    } else {
      currentStock = parseInt(currentStock) || 0;
    }

    let newStock;
    let isUnlimited = false;
    if (action === "set") {
      if (value === "" || value === null) {
        newStock = null;
        isUnlimited = true;
      } else {
        newStock = value;
        isUnlimited = false;
      }
    } else {
      newStock =
        action === "increment"
          ? currentStock + 1
          : Math.max(0, currentStock - 1);
      isUnlimited = false;
    }

    // Helper to dynamically update the React state
    const updateLocalState = (prodId, varId, stk, unlim) => {
      setItems((prevItems) =>
        prevItems.map((it) => {
          if (it.id === prodId) {
            const updatedVariants = it.variants.map((v) => {
              if (v._id === varId || v.variantId === varId) {
                return {
                  ...v,
                  branchStock: {
                    ...v.branchStock,
                    stock: stk,
                    isUnlimited: unlim,
                  },
                };
              }
              return v;
            });
            return { ...it, variants: updatedVariants };
          }
          return it;
        }),
      );

      if (selectedProduct && selectedProduct.id === prodId) {
        setSelectedProduct((prev) => {
          const updatedVariants = prev.variants.map((v) => {
            if (v._id === varId || v.variantId === varId) {
              return {
                ...v,
                branchStock: {
                  ...v.branchStock,
                  stock: stk,
                  isUnlimited: unlim,
                },
              };
            }
            return v;
          });
          return { ...prev, variants: updatedVariants };
        });
      }
    };

    // Optimistically update the UI first
    updateLocalState(productId, variantId, newStock, isUnlimited);

    // Call setVariantStock API
    const payload = {
      productId: productId,
      branchId: storeData?.data?._id,
      variants: [
        {
          variantId: variantId,
          stock: newStock,
          isUnlimited: isUnlimited,
        },
      ],
    };

    dispatch(setVariantStockAction(payload))
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message || "Stock limit updated successfully");
          if (storeData?.data?._id) {
            dispatch(
              ProductListAction({
                store:
                  storeData?.data?.mainBranchStoreId?._id || storeData?.data?._id,
                branchId: storeData?.data?._id,
              }),
            );
          }
        } else {
          toast.error(res.message || "Failed to update stock limit");
          // Revert state on API error response
          updateLocalState(
            productId,
            variantId,
            originalStock,
            originalIsUnlimited,
          );
        }
      })
      .catch((err) => {
        toast.error(err.message || "Failed to update stock limit");
        // Revert state on network/server error
        updateLocalState(
          productId,
          variantId,
          originalStock,
          originalIsUnlimited,
        );
      });
  };

  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleToggleStatus = (itemId) => {
    const item = items.find((i) => i.id === itemId);
    if (!item) return;

    const newStatus = item.status === "Active" ? "Inactive" : "Active";

    // Locally toggle first for instant UI response
    setItems((prevItems) =>
      prevItems.map((i) => (i.id === itemId ? { ...i, status: newStatus } : i)),
    );

    const payload = {
      productId: itemId,
      isEnabled: newStatus === "Active",
      branchId: storeData?.data?.mainBranchStoreId?._id,
    };

    dispatch(toggleBranchProductAction(payload))
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message || `Status updated to ${newStatus}`);
        } else {
          toast.error(res.message || "Failed to update status");
          // Revert local toggle
          setItems((prevItems) =>
            prevItems.map((i) =>
              i.id === itemId ? { ...i, status: item.status } : i,
            ),
          );
        }
      })
      .catch((err) => {
        toast.error(err.message || "Failed to update status");
        // Revert local toggle
        setItems((prevItems) =>
          prevItems.map((i) =>
            i.id === itemId ? { ...i, status: item.status } : i,
          ),
        );
      });
  };

  const handleStockChange = (itemId, action) => {
    setItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === itemId) {
          const newStock =
            action === "increment"
              ? item.stock + 1
              : Math.max(0, item.stock - 1);
          return { ...item, stock: newStock };
        }
        return item;
      }),
    );
  };

  // Filter products by search input
  const filteredProducts = items.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );

  const totalItems = items.length;
  const hiddenItems = items.filter((item) => item.status === "Inactive").length;

  const locationStatus = storeData?.data?.status || "Active";
  const statusColor =
    locationStatus.toLowerCase() === "active" ||
    locationStatus.toLowerCase() === "approved"
      ? "#10b981"
      : "#ef4444";

  const storeName = storeData?.data?.storeName;

  const storeAddress = storeData?.data?.address;

  return (
    <div>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FadeLoader color="#f56608" />
        </div>
      )}
      <Header />
      <SideNav />

      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            {/* Header Section */}
            <div style={{ marginBottom: "25px" }}>
              <h2
                style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: "0 0 5px 0",
                }}
              >
                Items & Stock
              </h2>
              <p style={{ margin: "0", fontSize: "14px", color: "#64748b" }}>
                {storeName} — {storeAddress} · managed by {storeName}
              </p>
            </div>

            {/* Banner/Info card */}
            <div
              style={{
                backgroundColor: "#fffbeb",
                border: "1px solid #fef3c7",
                borderRadius: "12px",
                padding: "20px",
                display: "flex",
                gap: "15px",
                marginBottom: "30px",
                color: "#b45309",
                fontSize: "14px",
                lineHeight: "1.6",
                boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
              }}
            >
              <div style={{ fontSize: "20px", marginTop: "-2px" }}>
                <i className="fa fa-lock"></i>
              </div>
              <div>
                You can{" "}
                <strong>hide or show items for this location only</strong> —
                toggle availability when something runs out. Items, prices and
                add-ons are set by head office and can't be changed here.
                Inventory is unlimited unless head office tracks stock for a
                specific item. Availability is independent per branch.
              </div>
            </div>

            {/* Stat Cards */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px",
                marginBottom: "30px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    color: "#64748b",
                    marginBottom: "8px",
                  }}
                >
                  Items on Menu
                </div>
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {totalItems}
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    color: "#64748b",
                    marginBottom: "8px",
                  }}
                >
                  Currently hidden
                </div>
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#ef4444",
                  }}
                >
                  {hiddenItems}
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    color: "#64748b",
                    marginBottom: "8px",
                  }}
                >
                  Location status
                </div>
                <div
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: statusColor,
                    textTransform: "capitalize",
                  }}
                >
                  {locationStatus}
                </div>
              </div>
            </div>

            {/* Search and Action Bar */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "25px",
                gap: "20px",
              }}
            >
              <div style={{ flex: "1", position: "relative" }}>
                <input
                  type="text"
                  placeholder="Item name..."
                  className="form-control"
                  value={search}
                  onChange={handleSearchChange}
                  style={{
                    paddingLeft: "15px",
                    height: "45px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            {/* Items List */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              {filteredProducts.length > 0 ? (
                filteredProducts.map((product) => {
                  // Extract first letters for Avatar placeholder
                  const initials = product.name
                    ? product.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .substring(0, 2)
                        .toUpperCase()
                    : "IT";

                  return (
                    <div
                      key={product.id}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "12px",
                        padding: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.01)",
                      }}
                    >
                      {/* Left: Info */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "15px",
                          flex: 1,
                          minWidth: 0,
                          marginRight: "20px",
                        }}
                      >
                        <div
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "10px",
                            backgroundColor: "#f1f5f9",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "700",
                            color: "#475569",
                            fontSize: "16px",
                            overflow: "hidden",
                            flexShrink: 0,
                          }}
                        >
                          {product.image ? (
                            <img
                              src={product.image}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                              alt={product.name}
                            />
                          ) : (
                            initials
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              flexWrap: "wrap",
                            }}
                          >
                            <h4
                              style={{
                                margin: "0",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#0f172a",
                              }}
                            >
                              {product.name}
                            </h4>
                            {product.productNumber && (
                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "#64748b",
                                  backgroundColor: "#f1f5f9",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  fontWeight: "600",
                                }}
                              >
                                #{product.productNumber}
                              </span>
                            )}
                            {product.type && (
                              <span
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "700",
                                  color:
                                    product.type.toLowerCase() === "veg"
                                      ? "#16a34a"
                                      : "#dc2626",
                                  border: `1.5px solid ${product.type.toLowerCase() === "veg" ? "#bbf7d0" : "#fecaca"}`,
                                  backgroundColor:
                                    product.type.toLowerCase() === "veg"
                                      ? "#f0fdf4"
                                      : "#fef2f2",
                                  padding: "1px 6px",
                                  borderRadius: "4px",
                                }}
                              >
                                {product.type}
                              </span>
                            )}
                          </div>

                          <div
                            style={{
                              fontSize: "13px",
                              color: "#64748b",
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                              marginTop: "4px",
                            }}
                          >
                            <span>{product.category}</span>
                            <span>·</span>
                            <span>{product.size}</span>
                            <span>·</span>
                            <span
                              style={{
                                fontSize: "13px",
                                fontWeight: "700",
                                color: "#3b82f6",
                                backgroundColor: "#eff6ff",
                                padding: "2px 8px",
                                borderRadius: "6px",
                              }}
                            >
                              SAR {product.price}
                            </span>
                          </div>

                          {product.description && (
                            <p
                              style={{
                                margin: "6px 0 0 0",
                                fontSize: "13px",
                                color: "#64748b",
                                fontStyle: "italic",
                              }}
                            >
                              {product.description}
                            </p>
                          )}

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                              marginTop: "8px",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#f1f5f9",
                                borderRadius: "20px",
                                padding: "4px 12px",
                                fontSize: "12px",
                                color: "#475569",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                fontWeight: "500",
                              }}
                            >
                              <i
                                className="fa fa-lock"
                                style={{ fontSize: "11px", color: "#64748b" }}
                              ></i>
                              Item, price & add-ons set by head office
                            </div>

                            {/* Add-ons tag */}
                            {product.addOns && product.addOns.length > 0 && (
                              <div
                                style={{
                                  backgroundColor: "#eff6ff",
                                  borderRadius: "20px",
                                  padding: "4px 12px",
                                  fontSize: "12px",
                                  color: "#1e40af",
                                  border: "1px solid #bfdbfe",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  fontWeight: "500",
                                }}
                              >
                                <strong>Add-ons:</strong>{" "}
                                {product.addOns
                                  .map((a) => `${a.name} (+SAR ${a.charges})`)
                                  .join(", ")}
                              </div>
                            )}

                            {/* Choices tag */}
                            {product.choices && product.choices.length > 0 && (
                              <div
                                style={{
                                  backgroundColor: "#faf5ff",
                                  borderRadius: "20px",
                                  padding: "4px 12px",
                                  fontSize: "12px",
                                  color: "#6b21a8",
                                  border: "1px solid #e9d5ff",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  fontWeight: "500",
                                }}
                              >
                                <strong>Choices:</strong>{" "}
                                {product.choices
                                  .map((c) => `${c.name} (+SAR ${c.charges})`)
                                  .join(", ")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Right: Controls */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "30px",
                          flexShrink: 0,
                        }}
                      >
                        {/* Variant List View Button */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "600",
                              color: "#94a3b8",
                              letterSpacing: "0.5px",
                            }}
                          >
                            VARIANTS ({product.variants?.length || 0})
                          </span>
                          <button
                            onClick={() =>
                              product.status === "Active" &&
                              handleViewVariants(product)
                            }
                            disabled={product.status === "Inactive"}
                            style={{
                              border: "1px solid #cbd5e1",
                              background:
                                product.status === "Inactive"
                                  ? "#f1f5f9"
                                  : "#fff",
                              borderRadius: "8px",
                              padding: "6px 16px",
                              fontSize: "13px",
                              fontWeight: "600",
                              color:
                                product.status === "Inactive"
                                  ? "#94a3b8"
                                  : "#0f172a",
                              cursor:
                                product.status === "Inactive"
                                  ? "not-allowed"
                                  : "pointer",
                              transition: "all 0.2s",
                              opacity: product.status === "Inactive" ? 0.6 : 1,
                            }}
                            onMouseEnter={(e) => {
                              if (product.status === "Active") {
                                e.currentTarget.style.backgroundColor =
                                  "#f8fafc";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (product.status === "Active") {
                                e.currentTarget.style.backgroundColor = "#fff";
                              }
                            }}
                          >
                            View
                          </button>
                        </div>

                        {/* Availability Toggle */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            gap: "5px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "600",
                              color: "#94a3b8",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {product.status === "Active"
                              ? "AVAILABLE"
                              : "HIDDEN"}
                          </span>
                          <label
                            className="switch"
                            style={{
                              margin: "0",
                              opacity: product.isEnabledForBranch ? 0.5 : 1,
                              cursor: product.isEnabledForBranch
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={product.status === "Active"}
                              disabled={product.isEnabledForBranch}
                              onChange={() =>
                                !product.isEnabledForBranch &&
                                handleToggleStatus(product.id)
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#64748b",
                  }}
                >
                  No items found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Variants Modal */}
      <VariantsModal
        show={showVariantsModal}
        onHide={() => setShowVariantsModal(false)}
        product={selectedProduct}
        onStockChange={handleVariantStockChange}
        isReadOnly={selectedProduct?.isEnabledForBranch}
      />
    </div>
  );
};

export default ItemsManagement;
